import { render } from "./InstructionsPage.vue?vue&type=template&id=3e59aa8c&scoped=true"
import script from "./InstructionsPage.vue?vue&type=script&lang=js"
export * from "./InstructionsPage.vue?vue&type=script&lang=js"

import "./InstructionsPage.vue?vue&type=style&index=0&id=3e59aa8c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e59aa8c"]])

export default __exports__